import * as types from "./actionTypes";
import { getLayout } from "../store/configureStore";
import * as DomainConstants from '../constants/DomainConstants';
import React from "react";
import {getTochtTypeText} from "../util/tochtTypeHelper";

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function loadExceptionPageLayout() {
	return function (dispatch) {

		let layout = getDefaultLayout();
		layout.scope = DomainConstants.DomainScopes.ZOEKMOTOR;
		layout.showHeader = false;
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadOverzichtPageLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();
		layout.pageHeaderTitle = ``;
		layout.pageHeaderSubtitle = '';
		layout.scope = DomainConstants.DomainScopes.ZOEKMOTOR;
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadDetailPageLayout(title, subtitle) {
	return function (dispatch) {

		let layout = getDefaultLayout();
		layout.scope = DomainConstants.DomainScopes.ZOEKMOTOR;
		layout.showHeader = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function getDefaultLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.ZOEKMOTOR;
	layout.showHeader = true;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = false;
	layout.showSideNav = true;
	layout.showBeads = false;

	return layout;
}
